<template>
	<IconUserNovated v-if="isNovated" class="w-6" />
	<IconUserDefault v-else class="w-6 fill-orange-400" />
</template>

<script setup>
import IconUserDefault from '@/assets/svg/common/ico-user-default.svg'
import IconUserNovated from '@/assets/svg/common/ico-user-novated.svg'

defineProps({
	isNovated: {
		type: Boolean,
		default: false,
		required: false,
	},
})
</script>
